<section class="main h-100 d-flex flex-column justify-content-center align-items-center">
	<h1>Coming Soon</h1>
	We're still updating our video library, this video should be available on Smart TV soon!

	<div dpadZone="'coming-soon'" class="mt-5">
		<button dpadSelectable class="btn dpad-start" (keyup.enter)="goBack()" (click)="goBack()">Go Back</button>
	</div>
</section>